import React, { useMemo } from "react";
import { Box, Button, FormControl, Grid, Card, TextField, IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import dayjs from "dayjs";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DateTimePicker2 } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AppLoading from "verticales/AppLoading.tsx";
import fetchData from "verticales/FetchData";
import TableMaestros from "verticales/TableMaestros.tsx";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import EmailIcon from "@mui/icons-material/Email";
import Tooltip from "@mui/material/Tooltip";
import UtilModal from "verticales/UtilModal.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.MuiMultiSectionDigitalClockSection-item": {
            fontSize: "1rem", // Change font size
            // color: "blue", // Change text color
            // backgroundColor: "lightyellow", // Change background color
          },
        },
      },
    },
  },
});

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "clientes-zeus-op";

const Example = (props) => {
  const [client, setClient] = React.useState("");
  const [fechaIni, setFechaIni] = React.useState(dayjs(new Date()));
  const [fechaFin, setFechaFin] = React.useState(dayjs(new Date()));
  const [subjectError, setSubjectError] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [blocking, setBlocking] = React.useState(false);
  const [msgAction, setMsgAction] = React.useState(context);

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const handleButtonClick = async () => {
    setSubjectError(false);

    const dateIni = fechaIni ? fechaIni.toDate() : null;
    const dateFin = fechaFin ? fechaFin.toDate() : null;

    const params = {
      action: "get",
      object: {
        client,
        fechaIni: dateIni,
        fechaFin: dateFin,
      },
    };

    setBlocking(true);
    setMsgAction("zeus");

    try {
      const resp = await fetchData(url, context, params);
      setData(resp.rows);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setData([]);
    } finally {
      setBlocking(false);
    }
  };

  const [rowSelect, setRowSelect] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = (row) => {
    setRowSelect(row);
    setOpenModal(true);
  };

  // const handleCloseModal = async (refresh) => {
  //   setOpenModal(false);
  // };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  //   const renderView = () => {
  //     return <DatosMail row={rowSelect} handleCloseModal={handleCloseModal} />;
  //   };

  /** datos table maestros11 */
  const columns = useMemo(
    () => [
      { header: "id", accessorKey: "id" },
      { header: "aplicacion", accessorKey: "aplicacion" },
      { header: "tipo aplicacion", accessorKey: "tipo_aplicacion" },
      { header: "version aplicativo", accessorKey: "version_aplicativo" },
      { header: "version sql", accessorKey: "version_sql" },
      { header: "revision", accessorKey: "revision" },
      { header: "nombre servidor", accessorKey: "nombre_servidor" },
      { header: "nombre db", accessorKey: "nombre_base_datos" },
      { header: "tamano base mb", accessorKey: "tamano_base_mb" },
      { header: "tamano log mb", accessorKey: "tamano_log_mb" },
      { header: "fecha creacion db", accessorKey: "fecha_creacion_base" },
      { header: "nit", accessorKey: "nit" },
      { header: "razon social", accessorKey: "razon_social" },
      { header: "direccion", accessorKey: "direccion" },
      { header: "fecha consulta", accessorKey: "fecha_consulta" },
      { header: "memoria servidor", accessorKey: "memoria_servidor" },
      { header: "motor db", accessorKey: "motor_db" },
      { header: "cores", accessorKey: "cores" },
      { header: "fecha service pack", accessorKey: "fecha_service_pack" },
    ],
    []
  );

  let renderOpcRowsSid = (row) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%", padding: "0" }}>
        <Tooltip title="Ver">
          <IconButton onClick={() => handleOpenModal(row)}>
            <EmailIcon />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <Card>
              <Grid item xs={12} md={6} lg={8}>
                <MDBox m={1}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Box sx={{ p: 2, flexGrow: 1 }}>
                      <Grid container spacing={2} alignItems="flex-end">
                        {/* Campo Nit */}
                        <Grid item xs={12} sm={6} md={2.5}>
                          <TextField
                            fullWidth
                            value={client}
                            id="client"
                            label="Nit"
                            onChange={(event) => setClient(event.target.value)}
                            sx={{
                              "& .MuiInputBase-input": {
                                padding: "12px",
                                fontSize: 13,
                              },
                            }}
                          />
                        </Grid>

                        {/* Fecha inicial */}
                        <Grid item xs={12} sm={6} md={3}>
                          <ThemeProvider theme={theme}>
                            <DateTimePicker
                              label="Inicial timestamp"
                              onChange={(newValue) => setFechaIni(newValue)}
                              value={fechaIni}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      padding: "12px",
                                      fontSize: 13,
                                    },
                                  }}
                                />
                              )}
                            />
                          </ThemeProvider>
                        </Grid>

                        {/* Fecha final */}
                        <Grid item xs={12} sm={6} md={3}>
                          <ThemeProvider theme={theme}>
                            <DateTimePicker
                              label="Final timestamp"
                              onChange={(newValue) => setFechaFin(newValue)}
                              value={fechaFin}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      padding: "12px",
                                      fontSize: 13,
                                    },
                                  }}
                                />
                              )}
                            />
                          </ThemeProvider>
                        </Grid>

                        {/* Botón */}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md="auto"
                          sx={{ display: "flex", justifyContent: "flex-start" }}
                        >
                          <MDButton
                            variant="contained"
                            disableElevation
                            onClick={handleButtonClick}
                            sx={{
                              height: 42,
                              alignSelf: "flex-end",
                            }}
                          >
                            Buscar
                          </MDButton>
                        </Grid>
                      </Grid>
                    </Box>
                  </LocalizationProvider>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox m={1}>
                  {blocking ? (
                    <AppLoading {...props} titleCustom={msgAction} />
                  ) : (
                    <TableMaestros
                      arrayColumns={columns}
                      data={data}
                      height={320}
                      handleOpenModal={handleOpenModal}
                      renderOpcRows={renderOpcRowsSid}
                    />
                  )}
                </MDBox>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default Example;
